@if (isLoading) {
    <mat-spinner></mat-spinner>
} @else {
    <div fxLayout="column" id="login">

        @if (!this.modeSSO) {
            <div fxLayout="column" fxLayoutAlign="center center" id="login-form-wrapper">
                <div id="login-form">
                    @if (settings.displayLoginLogo) {
                        <app-login-logo></app-login-logo>
                    }

                    @if (settings.displayPartnersLogo?.length > 0) {
                        <app-partners-logos [partnerLogos]="settings.displayPartnersLogo"></app-partners-logos>
                    }

                    @if (displaySessions) {
                        <app-sessions-list (loginSession)="onLoginSession($event)"></app-sessions-list>
                        <app-register-link></app-register-link>
                    } @else {
                        <app-gar-login></app-gar-login>

                        @if (settings.enableGAR && displayGARHelper && settings.enableFormLogin && entButtonAllowed) {
                            <div class="divider">
                                <span>
                                    {{ "generic.or" | translate }}
                                </span>
                            </div>
                        }

                        @if (!settings.enableGAR || !displayGARHelper) {
                            <h2 class="title mat-headline-6">
                                {{ "authentication.title" | translate }}
                            </h2>
                        }

                        @if (settings.enableSSO) {
                            <h3 class="sso-description">
                                {{ "authentication.sso.learner" | translate }}
                            </h3>
                        }

                        @if (settings.enableFormLogin) {
                            <app-login-form [login]="forceLoginValue()"></app-login-form>
                        }

                        @if (settings.enableSSO) {
                            <app-sso-login></app-sso-login>
                        }
                    }

                    <section class="login__section login__section-register-api"
                             *ngIf="activateAuthenticationByThirdParty">
                        <h2 class="title login__section-register-api__title">
                            {{ "login-section-register-api.title" | translate }}
                        </h2>

                        <div class="login__section-register-api__button-wrapper"
                             [class.has-iframe-focused]="isGoogleIframeFocused()">
                            <mat-icon svgIcon="google" class="login__section-register-api__button-icon"></mat-icon>
                            <span
                                class="login__section-register-api__button-text">{{ "authentication.btn-login-sign-in-google" | translate }}</span>
                            <div id="google-signin-button"></div>
                        </div>

                        <div class="login__section-register-api__button-wrapper">
                            <mat-icon svgIcon="apple" class="login__section-register-api__button-icon"></mat-icon>
                            <span
                                class="login__section-register-api__button-text">{{ "authentication.btn-login-sign-in-apple" | translate }}</span>
                            <div id="appleid-signin"></div>
                        </div>

                        <div class="login__section-register-api__button-wrapper">
                            <mat-icon svgIcon="facebook" class="login__section-register-api__button-icon"></mat-icon>
                            <span
                                class="login__section-register-api__button-text">{{ "authentication.btn-login-sign-in-facebook" | translate }}</span>
                            <button id="facebook-signin-button" (click)="signInWithFacebook()"></button>
                        </div>

                        <app-register-link></app-register-link>
                    </section>

                </div>
            </div>
        } @else {
            <div
                fxLayout="column"
                fxLayoutAlign="center center"
                id="login-sso-wrapper"
            >
                <div id="login-sso">
                    @if (settings.displayLoginLogo) {
                        <app-login-logo></app-login-logo>
                    }
                    <h2>{{ "authentication.sso.in-progress" | translate }}</h2>
                </div>
            </div>
        }

    </div>
}